import { Textual }	from "@v3/data/textual";

export type Fqdn	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"Fqdn",
		/^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.?)+$/,
		"must be a lowercase fqdn"
	);

namespace Extension {
	// ATTENTION: this is not just a subtype of string, but lowercase the input!
	export const reallyParse	= (it:string):Fqdn|null => Base.fromString(it.toLowerCase());
}

export const Fqdn	= { ...Extension, ...Base };
